<template>
  <v-card
    class="main__green purchase-table-card pa-0 mx-auto "
    elevation="0">
    <v-data-table
      v-model="choose"
      calculate-widths
      class="elevation-0 purchase-table mr-2  main__light_green"
      disable-pagination
      fixed-header
      :headers="headers"
      hide-default-footer
      item-key="id"
      :items="items"
      :no-data-text="$t('Tenders.NoData')"
      show-select
      @click:row="chooseItem">
      <template #[`item.approvedSupplyDate`]="{ item }">
        <DateSpan :item="item"/>
      </template>
      <template #[`item.creationDate`]="{ item }">
        <span>{{ item.creationDate | formatDate }}</span>
      </template>
      <template #[`item.number`]="{ item }">
        '#{{ item.number }}
      </template>
      <template #[`item.title`]="{ item }">
        <router-link
          style="max-width: 500px"
          :to="item.state != 'П' ?
            { name:'purchitem', params: {id: item.id, org: $route.params.org }}
            : {name: 'editing', query: {id : item.id}, params: {org: $route.params.org} }">
          <span class="h7-text-medium purch-name">{{ item.title || $t('Catalog.NewPurchase') }}</span>
        </router-link>
      </template>
      <template #[`item.responsible.fullName`]="{ item }">
        <PersonTooltip :item="item.creatorObject"/>
      </template>
      <template #[`item.status`]="{ item }">
        <ListOfAcceptors
          :acceptors="item.acceptors"
          :item="item"
          only_status/>
      </template>
      <template #[`item.summa`]="{ item }">
        <div class="flex flex-between">
          <div
            v-if="item.summa"
            class="flex flex-wrap align-center">
            {{ item.summa | formSum }}
            {{ getCurrencyName(item, item.summa) }}
          </div>
          <span
            v-else
            style=""> – </span>
        </div>
      </template>
      <template #[`item.comments`]="{ }">
        <CommentsCountBtn
          :comments_length="0"/>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import DateSpan from 'components/common/elements/DateSpan.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import ListOfAcceptors from 'components/agreement/ListOfAcceptors.vue'
import CommentsCountBtn from 'components/common/elements/CommentsCountBtn.vue'

import { snackbarMixin , filterSortMixin, applicationMixin, modalMixin} from 'mixins'

export default {
  name: 'purchTable',
  mixins: [ snackbarMixin, filterSortMixin, applicationMixin, modalMixin ],
  data() {
    return {
      acceptors: []
    }
  },
  props: {
    applications: {
      type: Array,
      required: true
    },
    choosed: Array,
    index: Number,
    // headers: Array
    choosedHeaders: Array,
    allHeaders: Array,
  },
  computed: {
    headers() {
      let headers = []
      this.allHeaders.forEach(el => {
        headers.push(Object.assign({}, el))
      })
      headers = headers.filter( el => {
        let item = this.choosedHeaders.find(elem => el.value == elem.value)
        return item
      })
      return headers
    },
    statuses() {
      return this.$store.getters.getStatuses
    },
    choose: {
      get() {
        return this.choosed
      },
      set(value) {
        this.$emit('update:choosed', value)
      }
    },
    items: {
      get() {
        return this.applications
      },
      set(value) {
        this.$emit('update:applications', value)
      }
    },
  },
  methods: {
    getStatus( item ) {
      return this.statuses?.find(el => el.id == item.statusId) || {}
    },
    chooseItem(item, options) {
      options.select(!options.isSelected)
    }
  },
  components: {
    DateSpan,
    PersonTooltip,
    ListOfAcceptors,
    CommentsCountBtn,
  }
}
</script>
<style lang="scss" scoped>
.purchase-table, .purchase-table-card {
  border-radius: 8px !important;
  //max-width: 1117px;
  // width: 1150px;

}
.comments {
   span {
    height: 16px;
    color: var(--black-color);
  }
  &.v-btn--disabled{
    opacity: 0.5;
  }
}
.purchase-table-card {
  overflow: auto;
}
</style>
<style lang="scss">
.purchase-table {
  .purch-name:hover{
    text-decoration-line: underline;
  }
  .v-data-table__wrapper {

    scrollbar-width: thin;
    scrollbar-color: rgba($color: var(--black-color), $alpha: 0.3) transparent;
    &::-webkit-scrollbar-thumb {
      max-width: 450px;
      width: 450px;
      background-color: rgba($color: var(--black-color), $alpha: 0.3);
    }
  }
  tr {
     cursor: pointer;
    .font-weight-medium:hover{
      text-decoration-line: underline;
    }
  }
}
.checkbox .v-messages {
  display: none;
}
</style>
